import React from 'react';
import TextInput from '../../components/form/TextInput';
import STRINGS from './../../data/language/language';
import Button from '../../components/buttons/Button';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';

const URL_SAVE = WS.meuTreino.save_carga;

export default class CargaBox extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      carga: '',
      strings: STRINGS[window.LANGUAGE]
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

    handleInputChange(event){
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;

      this.setState({
        [name]: value
      });
    }

    handleSubmit(event) {
      event.preventDefault();

      var self = this;
      const {
        atencao,
        salvoSucesso,
        preenchaCarga,
        erroSalvar
      }
      = this.state.strings;

      const id_exercicio = this.props.id;
      const carga = this.state.carga;

      const formData = {
        id_exercicio,
        carga
      };

      if(!id_exercicio || !carga){

        var msg = {
          title: atencao,
          text: preenchaCarga
        };

        Dialog.create(msg);
        return false;
      }else{

        Requisitions({
          url: URL_SAVE,
          data: formData,
          sucess:function(data){
            var msg = {
              title: atencao,
              text: data.msg
            };

            if(data.status){
              msg.text = salvoSucesso;
              self.props.onChange(carga);
            }

            Dialog.create(msg);
            const elem = document.querySelector('.modal-carga-box');
            elem.remove();
          },
          error:function(data){
            Dialog.create({
              title: atencao,
              text: erroSalvar
            });
          }
        });
      }
    }

  render(){
    const strings = this.state.strings;

    return(
      <div>
        <span className="title-add-carga">{strings.txtAddCarga}</span>
        <br />
        <div>
          <form onSubmit={this.handleSubmit}>
            <TextInput
              value={this.state.carga}
              onChange={this.handleInputChange}
              name="carga"
              title=''
              placeholder={strings.digiteAqui}>
            </TextInput>
            <div className="box-input">
              <Button
                text={strings.txtSalvar}
                type='submit'
                classes="button-login simple-button"
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/treino/CargaBox.js